
<section class="container">
  <div class="row mt-4">
    <div class="mt-3">
      <h1 class="mb-1">{{'topNavbar.usersTitle' | translate}}</h1>
      <p style="font-family:'MyFont-Light';">{{'headlines.userManagement' | translate}}</p>
    </div>
  </div>

  <div class="row">
    <div class="col-12">

      <mat-card class="mt-3">
        <mat-tab-group>
          <mat-tab label="Users">

            <ng-template mat-tab-label>
              <mat-icon class="example-tab-icon">manage_accounts</mat-icon>{{'users.title' | translate}}
            </ng-template>

            <div class="expansion-panel-content p-4">
              @if (userLength === 0) {
                <div class="row justify-content-center my-5">
                  <div class="col-8 text-center my-5 py-5">
                    <h1 class="mb-1">{{'topNavbar.users' | translate}}</h1>
                    <p class="lead pb-3" style="font-family:'MyFont-Light';">{{'empty_users' | translate}}</p>
                    <div [matTooltip]="!usersUserRights_create ? ('home.tooltip' | translate) : null">
                      <button mat-button class="orange-button" id="btn-create" (click)="openDialogCreateUser();" [disabled]="!usersUserRights_create" data-nar="add-user-btn">
                        <mat-icon>person_add</mat-icon> {{'add_new' | translate}}
                      </button>
                    </div>
                  </div>
                </div>
              }

              <div [ngClass]="{'d-none': userLength === 0}">
                <div class="row mt-2">

                  <div class="col-12">

                    <section class="filter-section d-flex flex-row flex-wrap align-items-center justify-content-between">
                      <div [matTooltip]="!usersUserRights_create ? ('home.tooltip' | translate) : null" class="d-flex flex-row flex-wrap">
                        <button mat-button class="orange-button my-1" id="btn-create" (click)="openDialogCreateUser();" [disabled]="!usersUserRights_create" data-nar="add-user-btn">
                          <mat-icon>person_add</mat-icon> {{'add_new' | translate}}
                        </button>
                      </div>

                      <mat-form-field class=" search">
                        <mat-label>{{'search_title' | translate}}</mat-label>
                        <input matInput (keyup)="applyFilter($event)" placeholder="{{'search' | translate}}" #input>
                        <mat-icon matPrefix>search</mat-icon>
                      </mat-form-field>
                    </section>

                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-12 mb-2">

                    <div class="mat-elevation-z8 rounded shadow-sm">
                      <table mat-table [dataSource]="dataSourceUsers" class="mat-table" matSort #sortUsers="matSort" matSortDisableClear>

                        <!-- Username -->
                        <ng-container matColumnDef="displayName">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'user.displayName' | translate}}"> {{ 'users.displayName' | translate }} </th>
                          <td mat-cell *matCellDef="let user"> {{user.displayName}} </td>
                        </ng-container>

                        <!-- Email -->
                        <ng-container matColumnDef="email">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'users.email' | translate}}"> {{ 'users.email' | translate }} </th>
                          <td mat-cell *matCellDef="let user"> {{user.email}} </td>
                        </ng-container>

                        <!-- Creation Date -->
                        <ng-container matColumnDef="creationDate">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'creation_date' | translate}}"> {{ 'creation_date' | translate }} </th>
                          <td mat-cell *matCellDef="let user"> {{ user.creationDate | date: 'dd.MM.yyyy, HH:mm' }} </td>
                        </ng-container>

                        <!-- Roles Column -->
                        <ng-container matColumnDef="roles">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'users.roles' | translate}}"> {{ 'users.roles' | translate }} </th>

                          <td mat-cell *matCellDef="let user">
                            @if (getUserRoles(user); as roles) {
                              @for (role of roles; track role) {
                                <div  class="role-chip m-1" [ngClass]="getRoleColor(role)"  matTooltip="{{ formatRoleName(role) }}"  matTooltipPosition="above">
                                  {{ getRoleAbbreviation(role) }}
                                </div>
                              }
                            }
                          </td>
                        </ng-container>

                        <!-- Status Column -->
                        <ng-container matColumnDef="status">
                          <th mat-header-cell *matHeaderCellDef> {{ 'Status' | translate }} </th>
                          <td mat-cell *matCellDef="let user">
                            @if (user.disabled) {
                              <span>{{'users.disabled' | translate}}</span>
                            }
                            @if (!user.disabled) {
                              <span>{{ user.state ? ('users.' + user.state | translate) : '-' }}</span>
                            }
                          </td>
                        </ng-container>

                        <!-- Actions Column -->
                        <ng-container matColumnDef="actions">
                          <th mat-header-cell *matHeaderCellDef></th>
                          <td mat-cell *matCellDef="let user">
                            <button mat-icon-button [matMenuTriggerFor]="menu">
                              <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                              <button mat-menu-item (click)="editUser(user);" [disabled]="!usersUserRights_create">
                                <mat-icon class="material-symbols-outlined">edit</mat-icon> {{'edit' | translate}}
                              </button>
                              @if ((user.state === 'registered' && !user.disabled)) {
                                <button mat-menu-item (click)="resetPassword(user.email);" [disabled]="!usersUserRights_create || !user.email">
                                  <mat-icon class="material-symbols-outlined">passkey</mat-icon> {{'users.resetPassword' | translate}}
                                </button>
                              }
                              @if (user.state === 'invited') {
                                <button mat-menu-item (click)="reinviteUser(user);" [disabled]="!usersUserRights_create">
                                  <mat-icon class="material-symbols-outlined">forward_to_inbox</mat-icon> {{'users.reinvite' | translate}}
                                </button>
                              }
                              <button mat-menu-item (click)="deleteUser(user);" [disabled]="!usersUserRights_create">
                                <mat-icon class="material-symbols-outlined delete">delete</mat-icon> {{'delete' | translate}}
                              </button>
                            </mat-menu>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsUsers"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsUsers;"></tr>

                      </table>
                      <mat-paginator #paginatorUsers class="pb-2" [pageSizeOptions]="paginatorSize" showFirstLastButtons [length]="userLength" [disabled]="userLength == 0" [hidden]="userLength <= 0"></mat-paginator>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="User Groups">
            <ng-template mat-tab-label>
              <mat-icon class="example-tab-icon">supervisor_account</mat-icon>{{'topNavbar.userGroups' | translate}}
            </ng-template>

            <div class="expansion-panel-content p-4">

              <div class="row">
                <div class="col-12">
                  <section class="topNavbar d-flex flex-row flex-wrap justify-content-between">
                    <button mat-button class="orange-button" id="btn-create" (click)="addGroup();" [disabled]="!userGroupsUserRights_create" data-nar="add-group-btn">
                      <mat-icon>add_circle</mat-icon> {{'userGroups.add_group' | translate}}
                    </button>
                  </section>
                </div>
              </div>

              <div class="expansion-panel-content py-4">

                @if(allGroups.length == 0) {
                  <div class="empty-list p-5 my-4 justify-content-center text-center">
                    <span class="text-muted">{{'taskTemplateGropus.no_groups' | translate}}</span>
                  </div>
                }
                <mat-accordion multi class="mt-3 form-field-section">
                  @for(group of allGroups; track group;let index = $index) {
                    <mat-expansion-panel expanded>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <span class="text-wrap text-break">{{ group.displayName }}</span>
                        </mat-panel-title>

                        <mat-panel-description>
                          <button mat-icon-button [matMenuTriggerFor]="editDelete" (click)="$event.stopPropagation()">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <mat-menu #editDelete="matMenu">
                            <button mat-menu-item (click)="editGroup(group);"><mat-icon>edit</mat-icon> {{"taskTemplates.editSectionTitle" | translate}}</button>
                            <button mat-menu-item (click)="deleteGroup(group);">
                              <mat-icon class="material-symbols-outlined delete">delete</mat-icon> {{"delete" | translate}}
                            </button>
                          </mat-menu>
                        </mat-panel-description>
                      </mat-expansion-panel-header>

                      <div class="expansion-panel-content">
                        <div class="shadow-sm rounded" >
                          @for(user of getUsersForGroup(group.id); track user;let index = $index) {
                            <div id="fields-list">
                              <div class="group-task-item d-flex flex-row flex-nowrap px-3 justify-content-between">
                                <div class="py-3 d-flex flex-column justify-content-center">
                                  <span class="text-break text-wrap">{{user.displayName}}</span>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </mat-expansion-panel>
                  }
                </mat-accordion>
              </div>
              <!-- table group users -->
              <!-- <ng-container>
              <div class="row mt-4">
                <div class="col-12 mb-4">
                  <div class="mat-elevation-z8 rounded shadow-sm">
                    <table mat-table [dataSource]="dataSourceUsersGroups" matSortActive="{{sortActive}}" [matSortDirection]="sortDirection" matSort #sortGroups="matSort" class="rounded">

                      <ng-container matColumnDef="displayName" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'displayName' | translate}}"> {{'displayName' | translate}} </th>
                        <td mat-cell *matCellDef="let data" (click)="editGroup(data);"> {{data.displayName}}</td>
                      </ng-container>

                      <ng-container matColumnDef="creationDate" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'creation_date' | translate}}"> {{'creation_date' | translate}} </th>
                        <td mat-cell *matCellDef="let data" (click)="editGroup(data);"> {{isDateTimeSeconds(data?.creationDate) | date:'dd.MM.yyy, HH:mm'}} </td>
                      </ng-container>

                      <ng-container matColumnDef="timeStamp" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'last_update' | translate}}"> {{'last_update' | translate}} </th>
                        <td mat-cell *matCellDef="let data" (click)="editGroup(data);"> {{isDateTimeSeconds(data?.timeStamp) | date:'dd.MM.yyy, HH:mm'}} </td>
                      </ng-container>

                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let data">
                          <button mat-icon-button (click)="deleteGroup(data);" [disabled]="!userGroupsUserRights_delete">
                            <mat-icon class="material-symbols-outlined delete">delete</mat-icon>
                          </button>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumnsGroups"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsGroups;"></tr>

                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">{{'no_matching_data' | translate}} </td>
                      </tr>
                    </table>
                    <mat-paginator #paginatorGroups [pageSizeOptions]="paginatorSize" aria-label="Select page of groups" showFirstLastButtons class="pb-2"></mat-paginator>
                  </div>
                </div>
              </div>
            </ng-container> -->

          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card>

  </div>
</div>
</section>
